import React, {Component} from 'react';
//import io from 'socket.io-client';
import Loading from "../Common/Loading";
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import {

    FaAngleLeft, FaAssistiveListeningSystems,
    MdBluetoothAudio,
    MdOutlineSimCard, RiAdminLine,
    TbReportSearch, TiWiFiOutline
} from "react-icons/all";
import {NavLink} from "react-router-dom";

class Device extends Component {
    state = {
        details: [],
        isLoaded: false,
    }

    render() {
        return (
            <React.Fragment>

                {
                    !this.state.isLoaded && <Loading />
                }
<Actionbar title='ارتباط با دستگاه ' noBack={1}/>

                <nav className="container-fluid profile-list-items mt-5 pt-5">
                    <div className="col-12 pt-2 ">

                    </div>

                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/home" >

                        <div className="col-1">
                            <TbReportSearch className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                           گزارش دستگاه
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/home" >

                        <div className="col-1">
                            <MdOutlineSimCard className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                           شارژ سیم کارت
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/home" >

                        <div className="col-1">
                            <TiWiFiOutline className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                           ارتباط با اینترنت
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/home" >

                        <div className="col-1">
                            <RiAdminLine className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                           نام کاربری و کلمه عبور
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/home" >

                        <div className="col-1">
                            <MdBluetoothAudio className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                          بلوتوث
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </NavLink>
                    <NavLink className="row mt-4 rtl px-4 menu-list-item" to="/home" >

                        <div className="col-1">
                            <FaAssistiveListeningSystems className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                          شنود
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>
                    </NavLink>


                </nav>

                <Navbar />
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        setTimeout (() => {
            this.setState({isLoaded : true})
            window.scrollTo({top: 0, behavior: 'smooth'});
        },5)

    }
}

export default Device;